import { deleteDoc, doc } from "firebase/firestore";
import { commentsCollection } from "../../../lib/firebase/firestore";

export const deleteComment = async (commentId: string) => {
  const commentRef = doc(commentsCollection, commentId);
  return deleteDoc(commentRef);
};
